"use strict";
/**
 * @license
 * Copyright 2017 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwnProperty = Object.prototype.hasOwnProperty;
function shallowEqualsPartial(state, partial) {
    if (state === partial) {
        return true;
    }
    for (var key in partial) {
        if (!hasOwnProperty.call(partial, key)) {
            continue;
        }
        if (!hasOwnProperty.call(state, key)) {
            return false;
        }
        if (partial[key] !== state[key]) {
            return false;
        }
    }
    return true;
}
exports.shallowEqualsPartial = shallowEqualsPartial;



//////////////////
// WEBPACK FOOTER
// ./node_modules/redoodle/lib/internal/utils/shallowEqualsPartial.js
// module id = 263
// module chunks = 0